import { Button, Stack, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconLoader from "../../../../../Common/components/IconLoader";

interface PublicBinahScanSuccessProps {
  onDone: () => void;
}

export default function PublicBinahScanSuccess({
  onDone,
}: PublicBinahScanSuccessProps) {
  const { t } = useTranslation();

  return (
    <Stack
      height="100%"
      alignItems="center"
      justifyContent="flex-start"
      p={2}
      bgcolor="primary.main"
      spacing={4}
      pt={16}
    >
      <IconLoader
        icon="PublicBinahScanSuccessIcon"
        sx={{ fontSize: 80 }}
        display="inline-block"
      />
      <Typography
        variant="h2"
        color="white"
        textAlign="center"
        fontSize={26}
        px={7}
      >
        {t("PublicBinahFaceScanSuccess.title")}
      </Typography>
      <Stack
        bgcolor="background.paper"
        sx={{
          borderRadius: (theme: Theme) =>
            `${theme.spacing(1.5)} ${theme.spacing(1.5)} 0 0`,
          bottom: "0",
          width: "100%",
          position: "absolute",
          px: 2,
          py: 1.5,
        }}
      >
        <Button fullWidth onClick={onDone}>
          {t("PublicBinahFaceScanSuccess.doneButton")}
        </Button>
      </Stack>
    </Stack>
  );
}
